import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { OwnerRoute } from './components/auth/OwnerRoute';
import { Layout } from './components/layout/Layout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import DocumentEditor from './pages/DocumentEditor';
import DocumentDetail from './pages/DocumentDetail';
import Revenue from './pages/Revenue';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          {/* Public route (no self-registration — F1.3). */}
          <Route path="/login" element={<Login />} />

          {/* Auth-guarded routes. Every nav entry maps to a real route. */}
          <Route element={<ProtectedRoute />}>
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <Dashboard />
                </Layout>
              }
            />
            <Route
              path="/documents"
              element={
                <Layout>
                  <Documents />
                </Layout>
              }
            />
            <Route
              path="/documents/new"
              element={
                <Layout>
                  <DocumentEditor />
                </Layout>
              }
            />
            <Route
              path="/documents/:id"
              element={
                <Layout>
                  <DocumentDetail />
                </Layout>
              }
            />
            <Route
              path="/documents/:id/edit"
              element={
                <Layout>
                  <DocumentEditor />
                </Layout>
              }
            />
            <Route
              path="/revenue"
              element={
                <Layout>
                  <Revenue />
                </Layout>
              }
            />
            <Route
              path="/403"
              element={
                <Layout>
                  <Forbidden />
                </Layout>
              }
            />

            {/* Owner-only areas (F1.3/F1.7/F9.1). */}
            <Route element={<OwnerRoute />}>
              <Route
                path="/settings"
                element={
                  <Layout>
                    <Settings />
                  </Layout>
                }
              />
              <Route
                path="/users"
                element={
                  <Layout>
                    <Users />
                  </Layout>
                }
              />
            </Route>
          </Route>

          {/* Default + catch-all redirects. */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
